import { useUserStore } from '~/modules/user/stores/userStore';

/**
 * Декоратор: пропускает вызов обёрнутой операции только для розничных
 * и гостевых пользователей (isRetail === true при user_type null | 'retail').
 * Для оптовых (wholesale) вызов полностью подавляется.
 *
 * Проверка ленивая (в момент вызова) — берётся актуальный user_type.
 * Сигнатура обёрнутой функции сохраняется.
 */
export const retailOnly = <T extends (...args: any[]) => void>(fn: T): T =>
  ((...args: Parameters<T>): void => {
    if (import.meta.server) return;
    if (!useUserStore().isRetail) return;
    fn(...args);
  }) as T;
